// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the
// presence of a DOM element with a given data attribute.

// This file is loaded globally but should just contain dynamically
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// Force top be imported as a chunked
// so it will be correctly versioned
// --------------------------------
if (true) {
  import('./main').then(({ mainJs }) => {
    mainJs();
  });
}

// --------------------------------
// Accordion component
// --------------------------------
const accordions = document.querySelectorAll('[data-module="accordion"]');

if (accordions.length > 0) {
  import('./modules/accordion').then(({ init }) => {
    accordions.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Content Accordion component
// --------------------------------
const contentAccordions = document.querySelectorAll('[data-module="content-accordion"]');

if (contentAccordions.length > 0) {
  import('./modules/content-accordion').then(({ init }) => {
    contentAccordions.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Card accordion component
// --------------------------------
const cardAccordions = document.querySelectorAll(
  '[data-module="card-accordion"]'
);

if (cardAccordions.length > 0) {
  if (window.matchMedia('(max-width: 767px)').matches) {
    import('./modules/cardAccordion').then(({ init }) => {
      cardAccordions.forEach((el) => {
        init(el);
      });
    });
  }
}

// --------------------------------
// Card carousel component
// --------------------------------
const cardCarousel = document.querySelectorAll('[data-module="card-carousel"]');

if (cardCarousel.length > 0) {
  import('./modules/cardCarousel').then(({ init }) => {
    cardCarousel.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Card carousel v2 component
// --------------------------------
const cardCarouselv2 = document.querySelectorAll(
  '[data-module="card-carousel-v2"]'
);

if (cardCarouselv2.length > 0) {
  import('./modules/cardCarouselv2').then(({ init }) => {
    cardCarouselv2.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Awards component
// --------------------------------
const awardsCarousels = document.querySelectorAll(
  '[data-module="awards-carousel"]'
);

if (awardsCarousels.length > 0) {
  import('./modules/awardsCarousel').then(({ init }) => {
    awardsCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Calendly 'Book A Demo' widget
// --------------------------------

const calendly = document.querySelectorAll('[data-module="calendly"]');

if (calendly.length > 0) {
  import('./modules/calendly').then(({ calendly }) => {
    calendly();
  });
}

// --------------------------------
// Column Scroll component
// --------------------------------
const columnScroll = document.querySelectorAll('[data-module="column-scroll"]');

if (columnScroll.length > 0) {
  import('./modules/columnScroll').then(({ init }) => {
    columnScroll.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Ethics
// --------------------------------
const ethicsComponents = document.querySelectorAll('[data-module="ethics"]');

if (ethicsComponents.length > 0) {
  import('./modules/ethics').then(({ init }) => {
    ethicsComponents.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Hero
// --------------------------------
const heroComponents = document.querySelectorAll('[data-module="hero"]');

if (heroComponents.length > 0) {
  import('./modules/hero').then(({ init }) => {
    heroComponents.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Image Testimonial components
// --------------------------------
const imageTestimonials = document.querySelectorAll(
  '[data-module="image-testimonial"]'
);

if (imageTestimonials.length > 0) {
  import('./modules/imageTestimonial').then(({ init }) => {
    imageTestimonials.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Location
// --------------------------------
const locationComponents = document.querySelectorAll(
  '[data-module="location"]'
);

if (locationComponents.length > 0) {
  import('./modules/location').then(({ init }) => {
    locationComponents.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Lottie animations
// --------------------------------
const lotties = document.querySelectorAll('[data-module="lottie"]');

if (lotties.length > 0) {
  import('./modules/lottie').then(({ init }) => {
    lotties.forEach((el) => {
      init(el);
    });
  });
}


const pagination = document.querySelectorAll('[data-module="pagination"]');

if (pagination.length > 0) {
  import('./modules/pagination').then(({ init }) => {
    pagination.forEach((el) => {
      init(el);
    })
  })
}

// --------------------------------
// Resource Carousel components
// --------------------------------
const resourceCarousels = document.querySelectorAll(
  '[data-module="resource-carousel"]'
);

if (resourceCarousels.length > 0) {
  import('./modules/resourceCarousel').then(({ init }) => {
    resourceCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Resources Hub Carousel components
// --------------------------------
const resourcesHubCarousels = document.querySelectorAll(
  '[data-module="resources-hub-carousel"]'
);

if (resourcesHubCarousels.length > 0) {
  import('./modules/resources-hub-carousel').then(({ init }) => {
    resourcesHubCarousels.forEach((el) => {
      init(el);
    });
  });
}


// --------------------------------
// Featired Hub carousel components
// --------------------------------
const featuredHubCarousel = document.querySelectorAll(
  '[data-module="featured-hub-carousel"]'
);

if (featuredHubCarousel.length > 0) {
  import('./modules/featured-hub-carousel').then(({ init }) => {
    featuredHubCarousel.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Resource Filter components
// --------------------------------
const resourceFilters = document.querySelectorAll(
  '[data-module="resource-filters"]'
);

if (resourceFilters.length > 0) {
  import('./modules/resourceFilters').then(({ init }) => {
    resourceFilters.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// HUB Resource Filter components
// --------------------------------
const mainResourceHub = document.querySelectorAll(
  '[data-module="main-resource-hub"]'
);

if (mainResourceHub.length > 0) {
  import('./modules/main-resource-hub').then(({ init }) => {
    mainResourceHub.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// HUB Resource Filter components
// --------------------------------
const singleResourceFilters = document.querySelectorAll(
  '[data-module="single-hub-resource-filters"]'
);

if (singleResourceFilters.length > 0) {
  import('./modules/single-hub-resource-filters').then(({ init }) => {
    singleResourceFilters.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Share links
// --------------------------------
const share = document.querySelectorAll('[data-module="share"]');
if (share.length > 0) {
  import('./modules/share').then(({ init }) => {
    share.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Subscribe popup
// --------------------------------
const subscribePopups = document.querySelectorAll(
  '[data-module="subscribe-popup"]'
);

if (subscribePopups.length > 0) {
  import('./modules/subscribePopup').then(({ init }) => {
    subscribePopups.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Hubspot popup
// --------------------------------
const buttonPopups = document.querySelectorAll(
  '[data-module="hubspot-popup"]'
);

if (buttonPopups.length > 0) {
  import('./modules/buttonPopup').then(({
    init
  }) => {
    buttonPopups.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Timeline components
// --------------------------------
const searchResults = document.querySelectorAll(
  '[data-module="search-results"]'
);

if (searchResults.length > 0) {
  import('./modules/searchResults').then(({ init }) => {
    searchResults.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Team component
// --------------------------------
const teamCarousels = document.querySelectorAll(
  '[data-module="team-carousel"]'
);

if (teamCarousels.length > 0) {
  import('./modules/teamCarousel').then(({ init }) => {
    teamCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Timeline components
// --------------------------------
const timelineCarousels = document.querySelectorAll(
  '[data-module="timeline-carousel"]'
);

if (timelineCarousels.length > 0) {
  import('./modules/timelineCarousel').then(({ init }) => {
    timelineCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Text Image Carousel components
// --------------------------------
const textImageCarousels = document.querySelectorAll(
  '[data-module="text-image-carousel"]'
);

if (textImageCarousels.length > 0) {
  import('./modules/textImageCarousel').then(({ init }) => {
    textImageCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Vertical Carousel components
// --------------------------------
const verticalCarousels = document.querySelectorAll(
  '[data-module="vertical-carousel"]'
);

if (verticalCarousels.length > 0) {
  import('./modules/verticalCarousel').then(({ init }) => {
    verticalCarousels.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// Video Testimonial components
// --------------------------------
const videoTestimonials = document.querySelectorAll(
  '[data-module="video-testimonial"]'
);

if (videoTestimonials.length > 0) {
  import('./modules/videoTestimonial').then(({ init }) => {
    videoTestimonials.forEach((el) => {
      init(el);
    });
  });
}


// --------------------------------
// Video components
// --------------------------------
const videos= document.querySelectorAll(
  '[data-module="video"]'
);
if (videos.length > 0) {
  import('./modules/video').then(({ init }) => {
    videos.forEach((el) => {
      init(el);
    });
  });
}


// --------------------------------
// Resource Banner Slider
// --------------------------------
const resourceBannerSlider= document.querySelectorAll(
  '[data-module="resource-banner-slider"]'
);
if (resourceBannerSlider.length > 0) {
  import('./modules/resourceBannerSlider').then(({ init }) => {
    resourceBannerSlider.forEach((el) => {
      init(el);
    });
  });
}


// --------------------------------
// Alt Image Testimonials
// --------------------------------
const altImageTestimonials= document.querySelectorAll(
  '[data-module="alt-image-testimonials"]'
);
if (altImageTestimonials.length > 0) {
  import('./modules/altImageTestimonials').then(({ init }) => {
    altImageTestimonials.forEach((el) => {
      init(el);
    });
  });
}

// --------------------------------
// ROI Calculator
// --------------------------------
const roiCalculator = document.querySelectorAll(
  '[data-module="roi-calculator"]'
);
if (roiCalculator.length > 0) {
  import('./modules/roi-calculator').then(({ init }) => {
    roiCalculator.forEach((el) => {
      init(el);
    });
  });
}